export const environment = {
    production: true,
    firebaseConfig: {
        apiKey: "AIzaSyCVXcMeXwwOLFdyQbf4WTPxl5z3EDsfmZk",
        authDomain: "acelera-movel-9cbed.firebaseapp.com",
        projectId: "acelera-movel-9cbed",
        storageBucket: "acelera-movel-9cbed.firebasestorage.app",
        messagingSenderId: "726266954549",
        appId: "1:726266954549:web:390875b17ac253ace4027c",
        measurementId: "G-0G898394R2"
    },
    appleStoreId: '6740704427',
    googleStoreId: 'br.com.icons4u.aceleramovel',
    googleMapsApiKey: 'AIzaSyAuQXtBFboYfCZoWuAdqybfAphPbOmudZg',
    config: {
        local: {
            _site: 'https://app.dev.aceleramovel.com.br/',
            _media: 'https://media.aceleramovel.com.br/',
            urlApiPadrao: 'http://localhost:3012/',
            // urlApiPadrao: 'https://api.dev.aceleramovel.com.br/',
            X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
            urlApiRekognition: 'https://20nl50bq4h.execute-api.us-east-1.amazonaws.com/dev',
            tokenRekognition: 'f8b044e7-e5a4-5024-8874-43ea46d34993',
            debugMode: 'info'
        },
        dev: {
            _site: 'https://app.dev.aceleramovel.com.br/',
            _media: 'https://media.aceleramovel.com.br/',
            urlApiPadrao: 'https://api.dev.aceleramovel.com.br/',
            // urlApiPadrao: 'https://api.aceleramovel.com.br/',
            X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
            urlApiRekognition: 'https://20nl50bq4h.execute-api.us-east-1.amazonaws.com/dev',
            tokenRekognition: 'f8b044e7-e5a4-5024-8874-43ea46d34993',
            debugMode: 'info'
        },
        hom: {
            _site: 'https://app.hom.aceleramovel.com.br/',
            _media: 'https://media.aceleramovel.com.br/',
            urlApiPadrao: 'https://api.dev.aceleramovel.com.br/',
            X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
            urlApiRekognition: 'https://20nl50bq4h.execute-api.us-east-1.amazonaws.com/dev',
            tokenRekognition: 'f8b044e7-e5a4-5024-8874-43ea46d34993',
            debugMode: 'off'
        },
        prod: {
            _site: 'https://app.aceleramovel.com.br/',
            _media: 'https://media.aceleramovel.com.br/',
            urlApiPadrao: 'https://api.aceleramovel.com.br/',
            X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
            urlApiRekognition: 'https://20nl50bq4h.execute-api.us-east-1.amazonaws.com/prod',
            tokenRekognition: 'f8b044e7-e5a4-5024-8874-43ea46d34993',
            debugMode: 'off'
        }
    }
};
